import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "../views/Home";
import Authenticate from "../views/Authenticate";
import BaseItemIndex from "../views/BaseItem";
import BaseShowItem from "../views/BaseItem/show";
import BaseCreateItem from "../views/BaseItem/create";
import BaseUpdateItem from "../views/BaseItem/update";
import { NavbarLayout } from "./NavbarLayout";
import { ErrorPage, ModelErrorPage } from "../views/ErrorPages";
import TestPage from "../views/TestPage";
import BaseSingleItem from "../views/BaseSingleItem";
import UpdateSingleItem from "../views/BaseSingleItem/update";
import Logout from "../views/Logout";
import { useAtomValue } from "jotai";
import { loginStatusAtom, userAtom } from "../atoms";
import CreateUser from "../views/Users/create";
import EditUser from "../views/Users/update";
import ShowUser from "../views/Users/show";
import UserIndex from "../views/Users";
import SlidesIndex from "../views/Slides";
import CreateSlides from "../views/Slides/create";
import ShowSlides from "../views/Slides/show";
import UpdateSlides from "../views/Slides/update";
import WorkPhotosIndex from "../views/WorkOrPhotos";
import WorkPhotosShow from "../views/WorkOrPhotos/show";
import CreateWorkPhotos from "../views/WorkOrPhotos/create";
import UpdateWorkPhotos from "../views/WorkOrPhotos/update";
import Settings from "../views/Settings";
import RequestReset from "../views/RequestReset";
import ResetPassword from "../views/ResetPassword";

const PrivatePages = (): JSX.Element => {
  const loginStatus = useAtomValue(loginStatusAtom);
  return loginStatus ? <NavbarLayout /> : <Logout />;
};

const AppRoutes = () => {
  const user = useAtomValue(userAtom);
  const admin = user?.user_role === "admin";
  return (
    <BrowserRouter>
      <Routes>
        <Route index element={<Authenticate />} />
        <Route path="/login" element={<Authenticate />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/another_hidden_signup_page" element={<Settings />} />
        <Route path="*" element={<ErrorPage />} />
        <Route path="/request_reset" element={<RequestReset />} />
        <Route path="/reset_password" element={<ResetPassword />} />
        <Route element={<PrivatePages />}>
          <Route path="/home" element={<Home />} />
          <Route path="/test" element={<TestPage />} />
          <Route path="/m/slides" element={<SlidesIndex />} />
          <Route path="/m/slides/create" element={<CreateSlides />} />
          <Route path="/m/slides/show/:id" element={<ShowSlides />} />
          <Route path="/m/slides/edit/:id" element={<UpdateSlides />} />
          <Route path="/m/:model" element={<WorkPhotosIndex />} />
          <Route path="/m/:model/create" element={<CreateWorkPhotos />} />
          <Route path="/m/:model/edit/:id" element={<UpdateWorkPhotos />} />
          <Route path="/m/:model/show/:id" element={<WorkPhotosShow />} />
          <Route path="/si/:item" element={<BaseSingleItem />} />
          <Route path="/si/:item/edit" element={<UpdateSingleItem />} />
          <Route path="/m/error" element={<ModelErrorPage />} />
          <Route
            path="/m/users/"
            element={admin ? <UserIndex /> : <ModelErrorPage />}
          />
          <Route
            path="/m/users/create"
            element={admin ? <CreateUser /> : <ModelErrorPage />}
          />
          <Route
            path="/m/users/show/:id"
            element={admin ? <ShowUser /> : <ModelErrorPage />}
          />
          <Route
            path="/m/users/edit/:id"
            element={admin ? <EditUser /> : <ModelErrorPage />}
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;
